export default "__VITE_ASSET__DHBrt3CL__"